import { Box, Grid, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import Chart, { useChart } from '../../chart';
import { blueGrey, indigo } from '@mui/material/colors';

const GlobalIccPieChartV2 = ({
    idclient, 
    idclientprogram, 
    period,
    first_time_male_data,
    follow_up_male_data,
    first_time_female_data,
    follow_up_female_data,
}) => {


    return ( 
        <Box>
            <Typography variant='h5' gutterBottom>
                Clasificación ICC
            </Typography>
            <Stack spacing={2}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant='h6' align='center'>Género masculino</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {first_time_male_data && <AnalyticChartPie title={"Colaboradores de primera vez"} data={first_time_male_data} />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {follow_up_male_data && <AnalyticChartPie title={"Colaboradores de seguimiento"} data={follow_up_male_data} />}
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'}>
                    <Grid item xs={12} md={4}>
                        <InfoTable 
                            head={["ICC", "Diagnóstico"]}
                            data={[
                                ["Sin riesgo","< 0.95"],
                                ["Riesgo Alto","> 0.95"],
                            ]}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant='h6' align='center'>Género femenino</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {first_time_female_data && <AnalyticChartPie title={"Colaboradores de primera vez"} data={first_time_female_data} />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {follow_up_female_data && <AnalyticChartPie title={"Colaboradores de seguimiento"} data={follow_up_female_data} />}
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'}>
                    <Grid item xs={12} md={4}>
                        <InfoTable 
                            head={["ICC", "Diagnóstico"]}
                            data={[
                                ["Sin riesgo","< 0.85"],
                                ["Riesgo Alto","> 0.85"],
                            ]}
                        />
                    </Grid>
                </Grid>
            </Stack>
        </Box>
     );
}
 
export default GlobalIccPieChartV2;

const AnalyticChartPie = ({
    title,
    data,
}) => {


    const chartOptions = useChart({
        labels: data?.labels??[],
        legend: {
            position:'bottom'
        },
        colors:data?.colors??[]
    })

    return(
        <div>
            <Typography variant='subtitle1' align='center'>
                {title}
            </Typography>
            <Typography variant='body2' align='center'>
                Data de {data.users_count} colabaradores
            </Typography>
            <Box sx={{p:2}}>
                <Box
                    sx={{
                        width:'100%',
                        maxWidth:800,
                        margin:'auto'
                    }}
                    
                >
                    <Chart
                        type="donut" 
                        series={data.data} 
                        options={chartOptions}
                    />
                </Box>
            </Box>
        </div>
    )
}

const InfoTable = ({
    head,
    data
}) => {
    return(
        <Table>
            <TableHead >
                <TableRow>
                    {head.map(item => {
                        return(
                            <TableCell key={item} sx={{
                                background: indigo[700],
                                color:'white',
                                py:0,
                                fontSize:12
                            }}>
                                {item}
                            </TableCell>
                        )
                    })}
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row, key) => {
                    return(
                        <TableRow key={`rowitem-${key}`}>
                            {row.map((el, idx) => {
                                return(
                                    <TableCell key={`rowcolitem-${key}-${idx}`} sx={{
                                        py:0,
                                        border:`1px solid ${blueGrey[50]}`,
                                        fontSize:12
                                    }}>
                                        {el}
                                    </TableCell>
                                )
                            })}
                        </TableRow>
                    )
                })}
                
            </TableBody>
        </Table>
    )
}